import { RouteType } from "types/RouteType";
import PurchasingRoute from "./Purchasing.Route";
import QuoteGenerationRoute from "./QuoteGeneration.Route";
import SalesOrderConversionRoute from "./SalesOrderConversion.Route";
import PurchasingHubRoute from "./PurchasingHub.Route";

const purchasingRoutesList: RouteType[] = [
  // Starter Purchasing module (2026-06-25): /purchasing with 4 tabs.
  PurchasingHubRoute,
  // Legacy sales-order workflow (hidden) — kept registered while it's still
  // referenced from older nav entries.
  PurchasingRoute,
  QuoteGenerationRoute,
  SalesOrderConversionRoute,
];

export default purchasingRoutesList;